module.exports = __webpack_public_path__ + "img/1.7ce01e57.jpg";